import axios from 'axios'
const baseUrl = process.env.VUE_APP_API_URL;


const userRequest = axios.create({
    baseURL: baseUrl,
    headers: { 
        'Content-Type': 'application/json',
        },
  });


  export const OregSample = (samplekey) => userRequest.post(`/api/SignUpDetail?SampleKey=${samplekey}`)
  export const SignUpWithSample = (data) => userRequest.post('/api/SignUpWithSample',data);
  export const Member = (token) => userRequest.get(`/api/Member?token=${token}`)